import React from "react";
import { Helmet } from "react-helmet";
import { Redirect } from "react-router-dom";

import { Partners } from "features/Partners";
import { useIsSuperUser } from "shared/hooks/useIsSuperUser";
import { PageTitle } from "shared/ui/PageTitle";

const PartnersPage = () => {
    const isSuperUser = useIsSuperUser();

    if (!isSuperUser) return <Redirect to="/branchesRegister/general" />;

    return (
        <>
            <Helmet title="Партнёры" />
            <PageTitle>Партнёры</PageTitle>
            <Partners />
        </>
    );
};

export default PartnersPage;
